
export type SourceBook = 'Bible' | 'Quran' | 'Talmud';

export interface Lesson {
  id: string;
  date: string; // ISO format
  title: string;
  theme: string;
  source: SourceBook;
  extract: string;
  reference: string;
  principle: string;
  action: string;
  prayer: string;
  isFavorite?: boolean;
  notes?: string;
}

export interface UserProfile {
  pin: string;
  language: string;
  subscription: {
    plan: 'FREE' | 'GOLD';
    startDate: string;
    expiresAt: string | null;
    isTrial: boolean;
  };
  firstLogin: string;
}

export interface AppState {
  lessons: Lesson[];
  profile: UserProfile | null;
  currentLesson: Lesson | null;
}

export enum AppStatus {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  AUTHENTICATED = 'AUTHENTICATED',
  PAYWALL = 'PAYWALL',
  LOCKED = 'LOCKED'
}
